import ViewUI from 'view-design';
import axios from 'axios';

axios.interceptors.request.use((config) => {
    if (config.method === 'post' && !(config.data instanceof FormData)) {
        const data = config.data;
        const formData = new FormData();
        for (const key in data) {
            if (key === '') {
                continue;
            }
            if (data[key] === null || data[key] === undefined || data[key] === '' || (typeof (data[key]) === 'number' && isNaN(data[key]))) {
                continue;
            }
            formData.append(key, data[key]);
        }
        config.data = formData;
    }
    return config;
});

axios.interceptors.response.use((response) => {
    if (response.data.code === 499) {
        localStorage.removeItem('loginToken');
        localStorage.removeItem('VUEMenuRouter');
        ViewUI.Modal.error({
            title: '登录已过期',
            content: '<p>登录已过期，请重新登录！</p>',
            okText: '跳回登录页',
            onOk: () => {
                window.location.href = '/';
            }
        });
    }
    return response.data;
});

export default axios;
